import * as RadixDialog from '@radix-ui/react-dialog'
import { keyframes, styled } from '../../../config'

const contentShow = keyframes({
  '0%': { opacity: 0, transform: 'translate(-50%, -48%) scale(.96)' },
  '100%': { opacity: 1, transform: 'translate(-50%, -50%) scale(1)' }
})

export const Content = styled(RadixDialog.Content, {
  zIndex: 2147483647,
  position: 'fixed',
  top: '50%',
  left: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  borderRadius: '$8',
  background: '#232323',
  color: '$gray0200',
  maxHeight: '95vh',
  overflowY: 'auto',
  width: '95vw',
  maxWidth: '550px',
  boxShadow: '0px 4px 30px 0px #00000040',
  animation: `${contentShow} 600ms cubic-bezier(0.16, 1, 0.3, 1)`,
  '@mobile': {
    width: 'fit-content'
  },

  // scrollbar
  '&::-webkit-scrollbar': {
    width: '4px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'none'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: '8px',
    background: '$gray0600',
    transition: '150ms'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '$gray0500'
  },
  variants: {
    minWidth: {
      500: {
        minWidth: '500px'
      }
    }
  }
})
